module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_6005.9b88b68c.png";